import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { resetSearchDraftClusters } from 'src/models/search/common/clusters/draft';
import { resetSearchDraftClustersOrder } from 'src/models/search/common/clustersOrder/draft';
import { setSearchGeoDrawerClosed } from 'src/models/search/common/geoDrawer';

export const useCloseGeoDrawer = (): (() => void) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch([setSearchGeoDrawerClosed(), resetSearchDraftClusters(), resetSearchDraftClustersOrder()]);
    }, [dispatch]);
};
